export default "__VITE_ASSET__CfQFcopl__"